if (!customElements.get('complementary-product-slider')) {
  customElements.define(
    'complementary-product-slider',
    class ComplementaryProductSlider extends HTMLElement {
      constructor() {
        super();

        const perView = this.dataset.slidesPerView;
        const perGroup = this.dataset.slidesPerGroup;

        this.sliderOptions = {
          slidesPerView: perView ? (perView === 'auto' ? 'auto' : parseFloat(perView)) : '1',
          slidesPerGroup: perGroup ? parseInt(perGroup, 10) : 1,
          spaceBetween: this.dataset.spaceBetween ? parseInt(this.dataset.spaceBetween, 10) : 10,
          loop: this.dataset.loop !== 'false',
          grabCursor: false,
          allowTouchMove: true,
          autoHeight: true,
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'bullets',
          },
        };
      }

      connectedCallback() {
        const slider = this.querySelector('.swiper');
        this.sliderInstance = new window.FoxTheme.Carousel(slider, this.sliderOptions);
        this.sliderInstance.init();

        this.fixQuickviewDuplicate();
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
